import { PageHeader } from "../components/PageHeader";
import { ProjectCard } from "../components/ProjectCard";
import { projects } from "../data/projects";

export function ProjectsPage() {
  return (
    <section className="mx-auto w-full max-w-6xl px-5 py-6 sm:p-10 lg:p-12">
      <PageHeader
        eyebrow="GAMES // INDEX"
        title="Selected work and active systems."
        description="Games and mods designed and built by Project Despair. Each entry carries its key art, role, tech, and the systems that were actually shipped."
      />

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {projects.map((project) => (
          <ProjectCard key={project.slug} project={project} />
        ))}
      </div>
    </section>
  );
}
